import { getServiceClient } from '@api/client-factory/StoreManagementClientFactory'

import {
    GetCameraPlanVersionsRequest,
    GetCameraPlanVersionsResponse,
    GetCameraInstallationInstructionsRequest,
    GetCameraInstallationInstructionsResponse,
    GetCameraPositionsRequest,
    GetCameraPositionsResponse,
    CommitAdjustedCamerasRequest,
    CommitAdjustedCamerasResponse,
} from '@amzn/coral_com-amazon-ihmcameraplanningservice'
import { validateRequired } from './listenerUtils'

// ========================================
// READ OPERATIONS (ViewBringUp)
// ========================================

export async function getCameraPlanVersionsListener (message: any): Promise<GetCameraPlanVersionsResponse> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getCameraPlanVersions(GetCameraPlanVersionsRequest.clone(params)).toPromise()
}

export async function getCameraInstallationInstructionsListener (message: any): Promise<GetCameraInstallationInstructionsResponse> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getCameraInstallationInstructions(GetCameraInstallationInstructionsRequest.clone(params)).toPromise()
}

export async function getCameraPositionsListener (message: any): Promise<GetCameraPositionsResponse> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getCameraPositions(GetCameraPositionsRequest.clone(params)).toPromise()
}

// ========================================
// WRITE OPERATIONS (ManageBringUp)
// ========================================

export async function commitAdjustedCamerasListener (message: any): Promise<CommitAdjustedCamerasResponse> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.commitAdjustedCameras(CommitAdjustedCamerasRequest.clone(params)).toPromise()
}
